import { createApp } from 'vue'
import App from './App.vue'
import router  from "./router/index";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/icons/fontClound.css'
import '@/assets/public.css'
import '@/assets/menu.less'
import '@/assets/resetElement/table.less'
import 'swiper/swiper-bundle.css';


createApp(App).use(router).use(ElementPlus).mount('#app')

